@if (data$ | async; as data) {
  <div class="wrapper">
    @if (data.balances_fiat.length > 0) {
      <div class="title">
        <p>{{ 'WALLET.FIAT' | translate }}</p>
      </div>
      <div class="fiat">
        @for (balance of data.balances_fiat; track balance) {
          <div class="row">
            <app-wallet-balance-row
              [walletBalance]="balance"
              [selected]="data.wallet.code === balance.wallet.code"
              (onselect)="onSelect()"
            />
          </div>
        }
      </div>
    }
    <div class="title">
      <p>{{ 'Token' | translate }}</p>
    </div>
    <div class="fiat">
      @for (balance of data.balances_token; track balance) {
        <div class="row">
          <app-wallet-balance-row
            [walletBalance]="balance"
            (onselect)="onSelect()"
            [selected]="data.wallet.code === balance.wallet.code"
          />
        </div>
      }
    </div>
    <div class="title">
      <p>{{ 'WALLET.CRYPTO' | translate }}</p>
    </div>
    <div class="crypto">
      @for (balance of data.balances_crypto_show; track balance) {
        <div class="row">
          <app-wallet-balance-row
            [walletBalance]="balance"
            (onselect)="onSelect()"
            [selected]="data.wallet.code === balance.wallet.code"
          />
        </div>
      }
    </div>
    <div class="view-all" *ngIf="!data?.all" (click)="onViewAll(data)">
      <app-button-ldb label="WALLET.ATC" type="primary" size="90" />
    </div>
  </div>
} @else {
  <div class="loader">
    <div class="spinner"><app-spinner type="dots" /></div>
  </div>
}
